import {
  GAME_SCROLL_SAVE_REQUEST,
  GAME_SCROLL_USE_REQUEST,
  GAME_SCROLL_CLEAR,
  GAME_TABS_REQUEST,
  GAME_ERROR,
  GAME_CLASS_APPS_REQUEST,
  GAME_CLASS_LIST_REQURST,
  GAME_RANKS_TAB_REQUEST,
  GAME_RANKS_MORE_LIST_REQUEST,
  GET_GAME_CATEGORY_TAG,
  SET_GAME_CATEGORY_LIST,
  SET_GAME_CODE,
  SET_SELECTED_TAG,
  SET_SHOW_CATEGORY_TAG,
  GET_SEARCH_TAG,
  CLEAR_TAG,
  SET_SELECTED_A_TAG,
  GET_TAG_APP_LIST,
  SET_APP_SORT,
  GAME_EXT_SCREEN_REQUEST,
} from '../constants/game';

export const scrollSave = () => ({
  type: GAME_SCROLL_SAVE_REQUEST,
});

export const scrollUse = action => ({
  type: GAME_SCROLL_USE_REQUEST,
  action,
});

export const scrollClear = () => ({
  type: GAME_SCROLL_CLEAR,
});

export const getGameTabs = params => ({
  type: GAME_TABS_REQUEST,
  payload: params,
});

export const setGameError = error => ({
  type: GAME_ERROR,
  error: error,
});

export const getGameClassApps = params => ({
  type: GAME_CLASS_APPS_REQUEST,
  payload: params,
});

export const getGameClassList = params => ({
  type: GAME_CLASS_LIST_REQURST,
  payload: params,
});

export const getGameRankTabList = params => ({
  type: GAME_RANKS_TAB_REQUEST,
  payload: params,
});

export const getGameRankMoreList = params => ({
  type: GAME_RANKS_MORE_LIST_REQUEST,
  payload: params,
});

export const getGameCategoryTag = params => ({
  type: GET_GAME_CATEGORY_TAG,
  payload: params,
});

export const setGameCategoryTag = params => ({
  type: SET_GAME_CATEGORY_LIST,
  payload: params,
});

export const setGameCode = params => ({
  type: SET_GAME_CODE,
  payload: params,
});

export const setSelectedTag = params => ({
  type: SET_SELECTED_TAG,
  payload: params,
});

export const setShowCategoryTag = params => ({
  type: SET_SHOW_CATEGORY_TAG,
  payload: params,
});

export const getSearchTag = params => ({
  type: GET_SEARCH_TAG,
  payload: params,
});

export const clearTag = params => ({
  type: CLEAR_TAG,
  payload: params,
});

export const setSelectedATag = params => ({
  type: SET_SELECTED_A_TAG,
  payload: params,
});

export const setAppSort = params => ({
  type: SET_APP_SORT,
  payload: params,
});

export const getTagAppList = params => ({
  type: GET_TAG_APP_LIST,
  payload: params,
});
// 8.6 负一屏
export const getGameExtScreen = params => ({
  type: GAME_EXT_SCREEN_REQUEST,
  payload: params,
});
